<template>
  <main id="app">
    <Counter :step="step" :total="total" />
    <div class="relative" :class="'step_'+step">
      <Ccfwawa :info="form" :step="step" />
      <transition name="Fade">
       <section class="l-scene" v-if="Number(step) === -3">
        <div class="l-scene--monster">
          <svg xmlns="http://www.w3.org/2000/svg" width="1097.48" height="604.271" viewBox="0 0 1097.48 604.271">
              <g transform="translate(23825.27 -8645.3)">
                <g class="l-scene--monster-1" transform="translate(-23825.27 9069.987)" style="isolation: isolate"  fill="#1c5f5f">
                  <path d="M104.716,218.761c-1.623.949-2.883,14.99-2.883,14.99l13.509-5.511S106.342,217.812,104.716,218.761Z" transform="translate(117.21 -196.911)"/>
                  <path d="M109.007,216.676c-1.623.945-2.887,14.984-2.887,14.984l13.509-3.51S110.633,215.724,109.007,216.676Z" transform="translate(126.432 -201.377)"/>
                  <path d="M113.52,215.469c-1.639.92-3.142,14.943-3.142,14.943l13.572-3.28S115.162,214.552,113.52,215.469Z" transform="translate(135.591 -203.964)"/>
                  <path d="M121.515,214.675c-1.818.466-6.863,13.632-6.863,13.632l14.5-1.623S123.334,214.205,121.515,214.675Z" transform="translate(144.786 -205.597)"/>
                  <path d="M126.206,213.842c-1.818.466-6.863,13.629-6.863,13.629l13.957.309S128.034,213.372,126.206,213.842Z" transform="translate(154.877 -207.385)"/>
                  <path d="M130.868,213.867c-1.828.441-7.1,13.512-7.1,13.512l13.953.545S132.7,213.426,130.868,213.867Z" transform="translate(164.404 -207.328)"/>
                  <path d="M138.183,214.44c-1.878.009-9.983,11.546-9.983,11.546l14.461,1.963S140.067,214.424,138.183,214.44Z" transform="translate(173.93 -206.074)"/>
                  <path d="M142.937,214.776c-1.884.016-9.983,11.549-9.983,11.549l13.462,3.7S144.821,214.763,142.937,214.776Z" transform="translate(184.157 -205.351)"/>
                  <path d="M147.425,215.9c-1.875-.019-10.172,11.379-10.172,11.379l13.393,3.923S149.309,215.919,147.425,215.9Z" transform="translate(193.405 -203.497)"/>
                  <path d="M154.923,218.021c-1.79-.574-13.1,7.846-13.1,7.846l13.115,6.394S156.716,218.6,154.923,218.021Z" transform="translate(203.244 -198.994)"/>
                  <path d="M159.335,219.83c-1.787-.577-13.1,7.846-13.1,7.846l11.631,7.727S161.124,220.41,159.335,219.83Z" transform="translate(212.726 -195.103)"/>
                  <path d="M163.209,222.265c-1.777-.605-13.225,7.62-13.225,7.62l11.5,7.925S164.989,222.882,163.209,222.265Z" transform="translate(220.789 -189.873)"/>
                  <path d="M167.737,225.372c-1.7-.807-14.013,6.063-14.013,6.063l12.167,8.058S169.442,226.185,167.737,225.372Z" transform="translate(230.778 -186.653)"/>
                  <path d="M171.868,227.743c-1.7-.807-14.01,6.063-14.01,6.063l10.512,9.183S173.573,228.556,171.868,227.743Z" transform="translate(237.764 -181.931)"/>
                  <path d="M175.372,230.658c-1.683-.838-14.108,5.817-14.108,5.817l10.355,9.362S177.064,231.5,175.372,230.658Z" transform="translate(245.855 -180.015)"/>
                  <path d="M177.82,232.72c-1.78-.58-13.106,7.818-13.106,7.818l13.1,6.422S179.606,233.3,177.82,232.72Z" transform="translate(254.265 -178.768)"/>
                  <path d="M181.514,234.749c-1.828-.425-12.39,8.921-12.39,8.921l12.239,6.718S183.348,235.177,181.514,234.749Z" transform="translate(263.754 -176.738)"/>
                  <path d="M182.744,236.462c-1.79.006-9.542,10.988-9.542,10.988l12.832,3.558S184.54,236.456,182.744,236.462Z" transform="translate(272.844 -174.789)"/>
                  <path d="M8.782,0C7.134.006,0,10.125,0,10.125L11.811,13.4S10.44,0,8.782,0Z" transform="translate(460.262 64.151) rotate(3)"/>
                  <path d="M6.592,0C5.1.233,0,10.361,0,10.361l11.143,1.371S8.092-.221,6.592,0Z" transform="translate(473.356 66.898) rotate(3)"/>
                  <path d="M6.592,0C5.1.233,0,10.361,0,10.361l11.143,1.368S8.089-.227,6.592,0Z" transform="translate(485.604 69.335) rotate(3)"/>
                  <path d="M4.364.018C2.949.548,0,11.492,0,11.492l11.187-.908S5.786-.508,4.364.018Z" transform="translate(500.89 69.291) rotate(14)"/>
                  <path d="M4.364.018C2.946.548,0,11.492,0,11.492l11.19-.908S5.789-.508,4.364.018Z" transform="translate(513.734 72.155) rotate(13)"/>
                  <path d="M4.364.018C2.95.548,0,11.495,0,11.495l11.193-.908S5.789-.508,4.364.018Z" transform="translate(525.556 73.649) rotate(14)"/>
                  <path d="M2.266.042C.967.814,0,12.108,0,12.108L10.856,9.234S3.577-.726,2.266.042Z" transform="translate(540.059 76.489) rotate(21)"/>
                  <path d="M2.266.042C.964.808,0,12.105,0,12.105L10.859,9.234S3.577-.726,2.266.042Z" transform="matrix(0.883, 0.469, -0.469, 0.883, 554.159, 77.976)"/>
                  <path d="M2.266.042C.964.811,0,12.111,0,12.111L10.859,9.234S3.573-.727,2.266.042Z" transform="matrix(0.921, 0.391, -0.391, 0.921, 565.114, 79.84)"/>
                  <path d="M2.266.042C.964.811,0,12.111,0,12.111L10.859,9.234S3.573-.727,2.266.042Z" transform="matrix(0.921, 0.391, -0.391, 0.921, 700.932, 103.216)"/>
                  <path d="M2.266.042C.967.811,0,12.108,0,12.108L10.856,9.234S3.57-.727,2.266.042Z" transform="translate(576.099 80.649) rotate(19)"/>
                  <path d="M2.266.042C.967.811,0,12.108,0,12.108L10.856,9.234S3.57-.727,2.266.042Z" transform="translate(639.647 90.035) rotate(19)"/>
                  <path d="M2.266.042C.967.811,0,12.108,0,12.108L10.856,9.234S3.57-.727,2.266.042Z" transform="matrix(0.809, 0.588, -0.588, 0.809, 689.948, 99.559)"/>
                  <path d="M2.266.042C.967.811,0,12.105,0,12.105L10.859,9.231S3.573-.727,2.266.042Z" transform="matrix(0.951, 0.309, -0.309, 0.951, 589.554, 83.179)"/>
                  <path d="M2.266.042C.967.811,0,12.105,0,12.105L10.859,9.231S3.573-.727,2.266.042Z" transform="matrix(0.788, 0.616, -0.616, 0.788, 677.025, 98.415)"/>
                  <path d="M2.272.042C.967.808,0,12.105,0,12.105L10.853,9.234S3.57-.727,2.272.042Z" transform="matrix(0.914, 0.407, -0.407, 0.914, 603.153, 84.086)"/>
                  <path d="M2.266.043C.961.808,0,12.105,0,12.105L10.856,9.232S3.573-.729,2.266.043Z" transform="translate(614.601 85.869) rotate(20)"/>
                  <path d="M2.259.042C.967.814,0,12.114,0,12.114l10.853-2.88S3.57-.727,2.259.042Z" transform="translate(627.615 87.511) rotate(22)"/>
                  <path d="M2.259.042C.967.814,0,12.114,0,12.114l10.853-2.88S3.57-.727,2.259.042Z" transform="matrix(0.799, 0.602, -0.602, 0.799, 665.2, 94.706)"/>
                  <path d="M2.263.06C.964.829,0,12.129,0,12.129L7.062,6.076S3.577-.706,2.263.06Z" transform="matrix(0.799, 0.602, -0.602, 0.799, 654.113, 92.59)"/>
                  <path d="M740.482,374.648c-7.341,0-304.609,1.868-491.932,4-23.586.269-60.414-19.281-91.807-26.876s-60.336-7.222-69.5-7.222c-37.578,0-34.107-21.062-32.034-24.638H41.45c-38.25,0-34.959-24.259-33.162-32.66,2.4-10.476,13.782-16.487,23.669-2.663,16.479-19.2,30.166,5.852,30.166,5.852s3.457-3.189,6.914-3.189,6.915,3.189,6.915,3.189a7.663,7.663,0,0,1,5.531-3.189c3.832-.42,5.762,3.189,5.762,3.189a9.22,9.22,0,0,1,5.531-3.189c3.855-.8,6.453,4.046,6.453,4.046s2.114-3.412,5.07-4.046,6.453,3.189,6.453,3.189,2.782-3.4,5.3-3.189,4.774,4.046,4.774,4.046,3.737-4.046,6.75-4.046,5.3,4.046,5.3,4.046,6.683.905,10.371,0,2.866-7.289,2.866-7.289-2.433-28.7,15.589-31.317c15.554-2.234,16.764,22.547,16.764,22.547s4.071-26.394,21.838-21.895c20.76,5.256,17.086,36.116,16.967,37.1a165.966,165.966,0,0,1,23.023-9.5c.879-.3,1.784-.6,2.713-.926,5.1-1.636,10.809-3.271,17.067-4.727h.025c1.128-.252,2.285-.5,3.444-.759a189.78,189.78,0,0,1,20.807-3.312c1.308-.126,2.644-.255,3.974-.356a172.085,172.085,0,0,1,23.149-.35c1.481.05,2.99.151,4.5.3a152.266,152.266,0,0,1,22.194,3.416h.025c1.279.3,2.559.63,3.87.958a3.781,3.781,0,0,1,.58.173,115.613,115.613,0,0,1,22.219,8.5c1.235.6,2.436,1.232,3.643,1.859,35.464,18.876,82.883,37.241,131.818,45.185C559.386,340.477,735.108,359.387,740.482,374.648Z" transform="translate(-7.331 -252.555)"/>
                  <path d="M186.605,285.953c-.246,3.066-7.947-3.082-7.947-3.082s-2.193,8.552-4.185,8.146c-4.824-.98-9.847-6.214-9.847-6.214s-8.587,7.33-11.1,6.072-1.888-5.234-1.888-5.234-8.171,5.234-9.422,3.139,5.023-3.769,5.023-12.986-7.541-22.975-7.541-22.975l7.122-10.708S185.348,263.125,186.605,285.953Z" transform="translate(202.163 -146.478)"/>
                  <path d="M160.327,285.953c-.252,3.066-7.95-3.082-7.95-3.082s-2.193,8.552-4.191,8.146c-4.821-.98-9.844-6.214-9.844-6.214s-8.587,7.33-11.1,6.072-1.884-5.234-1.884-5.234-8.168,5.234-9.425,3.139,5.023-3.769,5.023-12.986-17.987-27.882-17.987-27.882l17.577-5.8S159.063,263.125,160.327,285.953Z" transform="translate(112.686 -146.478)"/>
                </g>
                <g class="l-scene--monster-2" transform="translate(-23571.734 8645.3)" fill="#1c5f5f">
                  <path d="M-6830.734,10319.617c33.2-4.088,35.482,47.606,30.237,77.947-36.03,9.65-45.378,11.774-45.378,11.774S-6863.938,10323.716-6830.734,10319.617Z" transform="translate(7148.978 -10207.276)"/>
                  <path d="M-7800.6,10464.052s48.407,72.676,24.161,194.871h54.79c21.25-64.762,21.9-176.014,21.9-176.014Z" transform="translate(8042.542 -10054.654)"/>
                  <path d="M-7795.552,10467s4.266,81.067-28.761,192.348h68.889c33.678-44.78,51.359-171.35,51.359-171.35Z" transform="translate(8296.896 -10055.077)"/>
                  <path d="M818.262,5869.05C712.995,5827.551,571.574,5977.7,590.1,6047.3c-1.9,24.1,48.911,107.406,81.421,135.785s80.9,36.7,80.9,36.7,14.089,62.663,3.8,114.064h52.693c8.226-24.393,17.835-81.292,15.811-114.064,21.892,6.166,64.746,11.271,118.048,15.787,34.251,28.322,40.2,48.471,50.319,98.277h87.122C1083.014,6011.521,923.529,5910.547,818.262,5869.05Z" transform="translate(-396.249 -5729.768)"/>
                  <path d="M300.668,0C240.53,24.819,217.235,53.071,168.255,140.83s-148-17.363-151.925-21.086C1.747,140.192,0,140.83,0,140.83S38.576,283.138,191.683,285.409,360.053,297.509,382.3,264C372.723,222.4,300.668,0,300.668,0Z" transform="matrix(0.891, 0.454, -0.454, 0.891, 130.979, 0)"/>
                  <path d="M13.632,55.219c103.906-96.26,182.744-51.061,199.4,17.244S164.626,259.437,104.468,256.3,25.93,235.989,0,189.283C38.383,131.9,13.632,55.219,13.632,55.219Z" transform="matrix(0.966, 0.259, -0.259, 0.966, 422.956, 86.444)"/>
                </g>
                <g class="l-scene--monster-3" transform="translate(-23616.15 8947.436)" fill="#1c5f5f">
                  <path d="M0,9.187s6.664,44.4,14.356,47.46S28.2,50.522,28.2,50.522L25.124,0S22.56,3.829,19.483,4.594s-6.622-2.777-6.622-2.777-3.631,8.135-6.2,8.9S0,9.187,0,9.187Z" transform="translate(230.41 227.841) rotate(5)"/>
                  <path d="M0,3.879s5.606,12.742,8.922,16.99S15.409,24.033,18.5,22.1s1.528-9.3.406-22.1Z" transform="translate(235.389 272.59) rotate(5)"/>
                  <path d="M0,48.086S6.664,3.688,14.355.626,28.2,6.751,28.2,6.751L25.124,57.273s-2.564-3.829-5.641-4.594-6.622,2.777-6.622,2.777-3.631-8.135-6.2-8.9S0,48.086,0,48.086Z" transform="translate(151.922 284.721) rotate(166)"/>
                  <path d="M0,19.924S5.606,7.182,8.922,2.934,15.409-.23,18.5,1.7s1.528,9.3.406,22.1Z" transform="translate(145.91 297.221) rotate(166)"/>
                  <path d="M283.434,139.79a35.374,35.374,0,0,1-.356-6.965c.783-11.749,8.163-21.2,17.39-27.851,7.445-5.365,17.247-6.463,26.315-5.114,1.419-10.368,6.823-22.412,17.225-25.728,10.131-3.23,23.492-2.478,33.174,2.013a48.122,48.122,0,0,1,11.5,7.441c2.867-7.652,7.419-14.165,15.923-18.238,12.7-6.08,29.313-5.929,41.1,2.143a35.232,35.232,0,0,1,11.182,12.454A39.513,39.513,0,0,1,475.2,75.18c13.616-.193,24.778,6.969,26.851,20.242,10.328-.687,18.251,5.808,18.373,15.943,18.129-3.085,24.3,13.419,23.271,20.862a20.711,20.711,0,0,1-4.6,10.2c15.427,8.5,15.107,29.879,5.728,38.594a16.733,16.733,0,0,1,7.049,16.9,13.589,13.589,0,0,1-6.806,9.011c10.785,24.4-3.235,29.792-15.625,32.12-6.484,27.33-39.9,34.507-56.752,20.32a32.179,32.179,0,0,1-.968,13.065c-3.332,10.733-12.172,19.007-22,23.891-16.2,8.054-36.7-.478-42.028-16.293a33.964,33.964,0,0,1-9.478,10.512c-7.6,5.656-19.007,7.352-27.814,3.917-5.656-2.2-9.943-6.646-13.262-11.687a37.109,37.109,0,0,1-27.393,6.9c-11.862-1.8-24.581-13.824-29.678-24.143a25.581,25.581,0,0,1-2.34-15.285,38.044,38.044,0,0,1-6.394.507c-8.621-.007-15.85-4.215-20.725-11.092-4.811-6.79-5.444-15.867-3.576-23.689a21.017,21.017,0,0,1,2.046-5.289,32.079,32.079,0,0,1-6.761-3.752c-10.634-7.849-18.2-18.832-18.59-32.288C243.116,153.27,264.038,136.546,283.434,139.79Z" transform="translate(-209.305 -26.722)"/>
                  <path d="M442.208,68.964s-4.463-9.169-19.226-5.2c-16.443,4.416-28.054,11.634-20.675,19.892s32.454,10.674,37.761,6.138S442.208,68.964,442.208,68.964Z" transform="translate(-355.693 -17.221)"/>
                  <path d="M454.356,88.982s-4.241,50.649-41.679,67.932-48.633-.131-51.716-16.644,17.608-61.24,26.8-69.661S454.356,88.982,454.356,88.982Z" transform="translate(-310.814 -22.692)"/>
                  <path d="M354.024,61.081c4.58-3.251,9.512-3.7,14.515-2.936,1.836-6.214,5.951-12.46,11.677-15.333,9.528-4.778,26.971,1.25,30.651,11.928a30.568,30.568,0,0,1,5.712-3.71c6.969-3.488,15.976-3.423,20.7,3.687a26.229,26.229,0,0,1,3.669,8.959,15.908,15.908,0,0,1,11.728,2.179c8.241,4.8,11.566,14.712,6.57,23.013a17.833,17.833,0,0,1-6.5,6.182c.333.458.654.92.95,1.378,2.253,3.48,1.49,9.183.543,12.951-1.183,4.7-5.817,7.743-9.5,10.3-8.92,6.193-20.87,3.556-29.269-2.049a44.986,44.986,0,0,1-5.073-3.969c-5.164,7.214-13.571,11.851-22.055,7.712-7.477-3.649-12.632-13.26-11.707-21.837a35.073,35.073,0,0,1-4.772,2.176c-15.237,5.416-26.763-9.262-27.752-23.251C343.655,71.9,349.036,64.619,354.024,61.081Z" transform="translate(-294.256 -41.154)"/>
                  <path d="M0,9.187s6.664,44.4,14.356,47.46S28.2,50.522,28.2,50.522L25.124,0S22.56,3.829,19.483,4.594s-6.622-2.777-6.622-2.777-3.631,8.135-6.2,8.9S0,9.187,0,9.187Z" transform="matrix(0.999, -0.035, 0.035, 0.999, 252.73, 228.86)"/>
                  <path d="M0,3.879s5.606,12.742,8.922,16.99S15.409,24.033,18.5,22.1s1.528-9.3.406-22.1Z" transform="matrix(0.999, -0.035, 0.035, 0.999, 263.123, 272.669)"/>
                  <path d="M0,48.086S6.664,3.688,14.355.626,28.2,6.751,28.2,6.751L25.124,57.273s-2.564-3.829-5.641-4.594-6.622,2.777-6.622,2.777-3.631-8.135-6.2-8.9S0,48.086,0,48.086Z" transform="translate(115.93 287.404) rotate(-178)"/>
                  <path d="M0,19.924S5.606,7.182,8.922,2.934,15.409-.23,18.5,1.7s1.528,9.3.406,22.1Z" transform="translate(106.703 297.763) rotate(-178)"/>
                </g>
                <g class="l-scene--monster-4" transform="translate(-23026.215 8877.207)" fill="#1c5f5f">
                  <path d="M141.627,377.61s.736-.012,2.113-.041c1.588-.043,3.726-.148,6.466-.435a72.026,72.026,0,0,0,22.221-5.89,47.8,47.8,0,0,0,13.234-8.931,39.767,39.767,0,0,0,9.83-15.112,49.16,49.16,0,0,0,2.775-18.343c-.037-1.546-.1-3.088-.276-4.61q-.179-2.307-.571-4.559l-.377-2.4-.454-2.115c-.379-1.546-.829-3.229-1.322-4.649a108.241,108.241,0,0,0-7.331-16.362c-2.678-5.082-5.381-9.915-7.62-14.653a59.009,59.009,0,0,1-4.913-13.849,27.344,27.344,0,0,1,.2-12.484,29.025,29.025,0,0,1,4.69-9.643,32.1,32.1,0,0,1,5.67-6.247,25.626,25.626,0,0,1,4.513-2.847c1.155-.515,1.767-.792,1.767-.792l-1.5-3.971-2.06.792a29.8,29.8,0,0,0-5.552,3.1,37.058,37.058,0,0,0-6.934,6.818,34.457,34.457,0,0,0-6.156,11.162,33.452,33.452,0,0,0-1.093,15.176,65.452,65.452,0,0,0,4.612,15.754c2.113,5.167,4.606,10.241,6.95,15.339a100.179,100.179,0,0,1,5.948,15.362c.373,1.328.6,2.451.854,3.711l.338,2.136.175,1.876c.159,1.344.249,2.674.274,4,.087,1.326.058,2.633.019,3.925a38.544,38.544,0,0,1-2.936,14.3,28.065,28.065,0,0,1-7.62,10.389,35.535,35.535,0,0,1-10.2,6.041,58.885,58.885,0,0,1-18.29,3.719c-2.291.109-4.119.093-5.237.066l-2.031-.076Z" transform="translate(88.199 -13.086)"/>
                  <path d="M175.729,353.506c4.585,13.179,14.766,25.945,14.766,25.945s-28.287,6.385-28.433,8.855c-.373,6.313,26.2,5.02,26.2,5.02h51.753c25.955,0,55.737-20.529,60.019-41.086,14.257-68.439-70.28-138.609-96.233-138.609S163.769,319.129,175.729,353.506Z" transform="translate(-57.274 -30.123)"/>
                  <path d="M162.658,259.628c5.618-25.693,14.719-46,26.1-46,25.953,0,102.567,75.974,96.233,138.609-1.113,10.993-12.517,21.166-24.254,29.07C253.411,322.273,208.738,284.635,162.658,259.628Z" transform="translate(-42.234 -30.123)"/>
                  <path d="M165.346,316.633a39.168,39.168,0,0,0,24.316,25.574s-18.25,3.033-18.391,5.356c-.35,5.932,5.855,6.5,5.855,6.5h37.09c17.38,0-.788-10.422,2.779-15.1,26.79-35.091-2.41-85.38-26.807-85.38S156.035,286.9,165.346,316.633Z" transform="translate(17.093 12.302)"/>
                  <path d="M193.431,345.364c1.495,15.512,14.933,29.105,40.888,29.105s45.6-14.024,47.005-28.646c3.35-35.037-21.042-168.028-47-168.028S190,309.723,193.431,345.364Z" transform="translate(-101.097 -68.17)"/>
                  <path d="M226.955,159.031c0-93.322-82.391-100.752-74.371-159.031C65.171,5.511,0,95.084,0,159.031,0,229.68,50.622,271.442,113.294,271.442S226.955,230.948,226.955,159.031Z" transform="translate(226.644 282.948) rotate(-177)"/>
                  <path d="M137.556,237.528c4.342-8.014,14.508-5.218,18.714-20.364,8.476,4.981,10.723,21.37,4.975,29.239-6.381,8.738-14.148,9.241-18.23,6.789C136.995,249.576,133.57,244.878,137.556,237.528Z" transform="translate(133.993 -26.372)"/>
                  <path d="M222.969,338.829s5.078,5.276-.186,6.54-18.618,4.8-19.193,1.264c-.934-5.692,11.366-7.8,11.366-7.8L196.847,264.8h26.122Z" transform="translate(-52.528 24.205)"/>
                  <path d="M248.184,344.912s5.078,5.276-.185,6.54-18.611,4.8-19.191,1.264c-.932-5.692,11.366-7.8,11.366-7.8l-18.112-85.84,26.122,11.812Z" transform="translate(-129.728 18.122)"/>
                </g>
              </g>
            </svg>
        </div>
          <div class="container">
            <div class="gap-3 col-5">
              <h3 class="l-scene--title">一起到動物森林探險吧</h3>
              <p class="l-scene--paragraph">聽說這個古老的森林裡有著許多動物。當你蒐集到11片樹葉時，神秘動物將會現身，揭開你與家人之間的關係奧秘…</p>
              <Btn type="green" @click.native="goNext()" class="l-scene--btn">探險開始</Btn>
            </div>
          </div>
        </section>
      </transition>
      <transition name="Fade">
       <section class="l-scene" v-if="Number(step) === -2">
          <div class="container">
            <div class="gap-3 col-4">
              <h3 class="l-scene--title">輸入你的暱稱</h3>
              <div class="formBox l-scene--paragraph">
                <input class="l-scene--input type-2" id="nickname" v-model="form.nickname" placeholder="輸入綽號..." :class="errorMsg ? '_error': ''">
                <p class="formBox--error" v-if="errorMsg">暱稱必填哦！</p>
              </div>
              <Btn type="green" @click.native="selectNicename()" class="l-scene--btn">確認</Btn>
            </div>
          </div>
        </section>
      </transition>
      <transition name="Fade">
       <section class="l-scene" v-if="Number(step) === -1 && form.type === null">
          <div class="container">
            <div class="gap-1">
              <h3 class="l-scene--title">你在家中擔任的角色是？</h3>
              <div class="flex ai-fe l-scene--svgpanel">
                <div class="svgBox" @click="goChild()">
                  <div class="svgBox-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="238" height="238" viewBox="0 0 238 238">
                      <defs>
                        <clipPath id="cp1">
                          <path d="M167.231-24.1C232.953-24.1,238,46.434,238,105.435S184.722,212.266,119,212.266,0,164.436,0,105.435C0,70.034.928,2.854,30.638-16.7,50.162-29.545,140.943-24.1,167.231-24.1Z" transform="translate(0 25.245)" fill="#efefef"/>
                        </clipPath>
                      </defs>
                      <g id="child" transform="translate(0 -25.419)">
                        <ellipse cx="118.704" cy="118.46" rx="118.704" ry="118.46" transform="translate(0 26.501)" fill="#DCE9E5"/>
                        <g transform="translate(0 25.42)" clip-path="url(#cp1)">
                          <g id="item">
                            <g transform="translate(4.683 14.532)">
                              <path d="M656.738,326.672c5.569,4.268,13.285,3.573,17.229-1.553s2.629-12.745-2.942-17.013-13.283-3.574-17.229,1.553S651.169,322.4,656.738,326.672Z" transform="translate(-605.525 -145.611)" fill="#e0a396"/>
                              <path d="M730.881,299.487l-26.815,26.148a10.931,10.931,0,0,1-11.656,4.118l-33.277-4.319" transform="translate(-597.693 -151.576)" fill="none" stroke="#e0a396" stroke-linejoin="round" stroke-width="10.075"/>
                              <path d="M653.564,350.2c-1.406,5.983-7.839,9.6-14.368,8.066s-10.68-7.617-9.274-13.6,7.839-9.6,14.368-8.066S654.971,344.215,653.564,350.2Z" transform="translate(-628.029 -120.566)" fill="#eab292"/>
                              <path d="M635.317,308.194,633.1,368.131l13.138,2.49,2.525-62.427Z" transform="translate(-624.484 -149.31)" fill="#eab292"/>
                              <path d="M651.764,286.345s-22.646,11.338-21.552,44.571c0,0,26.022,2.755,26.022,1.122S651.764,286.345,651.764,286.345Z" transform="translate(-627.49 -171.697)" fill="#fff"/>
                              <path d="M643.306,317.317l.364-16.1-6.338,15.741Z" transform="translate(-620.125 -156.458)" fill="#ddd"/>
                              <path d="M662.376,282.238s-7.486.441-20.489,8.315l-2.114,83.889,62.973,1.369-1-85.6s-13.279-8.072-20.422-7.973Z" transform="translate(-617.613 -175.906)" fill="#fff"/>
                              <path d="M696.69,298l53.322-8.757v13.494L689.9,316.853a8.348,8.348,0,0,1-8.643-3.859l-10.446-17.133Z" transform="translate(-585.682 -168.728)" fill="#eab292"/>
                              <path d="M662.716,282.65a112.078,112.078,0,0,1,42.96,21.828s-5.94,22.439-20.039,29.89L664.471,328.6Z" transform="translate(-594.01 -175.483)" fill="#fff"/>
                              <path d="M670.939,314.014l-.741-13.36,7.74,15.267Z" transform="translate(-586.313 -157.035)" fill="#ddd"/>
                              <path d="M640.973,327.779l-2.367,161.813h28.208l6.235-146.228,2.8,146.228h28.207l-.11-160.443Z" transform="translate(-618.813 -129.243)" fill="#1a6c54"/>
                              <path d="M648.644,407.7l-9.193,8.854h0c-8.462,5.3-10.211,10.1-10.53,12.385h-.039v.271a4.489,4.489,0,0,0,0,1.144v3.254H676.85V407.7Z" transform="translate(-628.85 -47.351)" fill="#1a6c54"/>
                              <path d="M704.93,429.21v-.271h-.039c-.318-2.288-2.067-7.09-10.53-12.385L685.17,407.7H656.963v25.907H704.93v-3.254A4.5,4.5,0,0,0,704.93,429.21Z" transform="translate(-599.926 -47.351)" fill="#1a6c54"/>
                              <path d="M37.963.032A37.919,37.919,0,1,1,.032,37.919,37.919,37.919,0,0,1,37.963.032Z" transform="translate(3.299 35.356) rotate(-27.801)" fill="#2f2424"/>
                              <rect width="18.944" height="22.686" rx="7" transform="translate(44.762 94.473)" fill="#e49980"/>
                              <path d="M672.108,262.048s3.011-4.778,9.219-2.428,3.4,17.4-5.914,19.315a7.379,7.379,0,0,1-5.957-1.555S671.746,266.265,672.108,262.048Z" transform="translate(-587.076 -193.092)" fill="#e49980"/>
                              <path d="M646.726,260.933s-3.011-4.778-9.219-2.428-3.4,17.4,5.914,19.315a7.38,7.38,0,0,0,5.957-1.555S647.087,265.15,646.726,260.933Z" transform="translate(-623.357 -194.234)" fill="#e49980"/>
                              <path d="M704.669,267.714c0,8.5-.888,26.278-6.478,36.83-5.246,9.909-13.924,15.24-25.3,15.557s-19.854-3.782-26.647-16.64-6.468-35.589-6.468-35.589,0-30.357,32.094-30.357C705.673,237.514,704.669,267.714,704.669,267.714Z" transform="translate(-617.613 -215.076)" fill="#eab292"/>
                              <ellipse cx="2.48" cy="2.475" rx="2.48" ry="2.475" transform="translate(36.996 64.117)" fill="#2f2424"/>
                              <ellipse cx="2.48" cy="2.475" rx="2.48" ry="2.475" transform="translate(65.5 64.117)" fill="#2f2424"/>
                              <path d="M654.342,262.022v2.239a3.233,3.233,0,0,0,.229,1.2,3.175,3.175,0,0,0,3.784,1.749l1.771-.47" transform="translate(-602.625 -189.964)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M658.428,253.53l18.578,4.79s-.844-5.2-8.444-7.09S658.428,253.53,658.428,253.53Z" transform="translate(-598.422 -201.524)" fill="#2f2424"/>
                              <path d="M662.158,253.53l-18.578,4.79s.844-5.2,8.444-7.09S662.158,253.53,662.158,253.53Z" transform="translate(-613.697 -201.524)" fill="#2f2424"/>
                              <path d="M649.688,267h24.06s-1.489,7.621-12.1,7.621S649.688,267,649.688,267Z" transform="translate(-607.414 -184.86)" fill="#fff"/>
                              <path d="M634.671,240.921c-.018-.018-.038-.034-.057-.055C634.614,240.866,634.636,240.89,634.671,240.921Z" transform="translate(-622.922 -211.641)" fill="#331b23"/>
                              <path d="M692.647,245.118a67.059,67.059,0,0,0-12.185-3.486,7.936,7.936,0,0,0-2.834,0l-.093.014c-.1-.034-.209-.067-.313-.1a7.2,7.2,0,0,0,.033-3.65c-1.664-6.673-7.9-7.734-11.286-7.8a7.387,7.387,0,0,0-5.159,1.96,9.292,9.292,0,0,0-2.865,5.007,34.167,34.167,0,0,0-10.836-1.733,16.048,16.048,0,0,0-8.336,2.073c-6.37,3.738-5.447,9.449-4.4,12.409a6.1,6.1,0,0,0,1.392,2.2.615.615,0,0,1-.075-.055,32.385,32.385,0,0,0,12.224,7.843,39.62,39.62,0,0,0-4.9,17.872c7.957-2.4,10.974-10.3,12.122-15.776,18.681,3.912,40.968-1.336,47.316-3.027.6,4.958,3,15.9,12.623,18.8C715.076,277.674,715.354,253.269,692.647,245.118Zm9.124,11.046.477.223s0,.069.006.192C702.1,256.448,701.935,256.306,701.771,256.164Z" transform="translate(-623.939 -222.679)" fill="#2f2424"/>
                              <path d="M721.321,351.847c1.357,5.78,7.572,9.269,13.879,7.793s10.316-7.36,8.957-13.138-7.572-9.269-13.877-7.793S719.962,346.069,721.321,351.847Z" transform="translate(-533.988 -111.734)" fill="#e0a396"/>
                              <path d="M736.574,311.275l2.146,57.895-12.691,2.4-2.439-60.3Z" transform="translate(-531.379 -139.498)" fill="#e0a396"/>
                              <path d="M725.78,290.17s21.873,10.953,20.82,43.052c0,0-25.137,2.662-25.137,1.083S725.78,290.17,725.78,290.17Z" transform="translate(-533.568 -161.123)" fill="#fff1cc"/>
                              <path d="M724.563,321.293l-.713-17.936,5.9,17.615Z" transform="translate(-531.113 -147.61)" fill="#edc8ad"/>
                              <path d="M734.553,286.2s7.233.425,19.791,8.032l2.043,73.6L693.7,369.164l2.83-75.258s12.826-7.8,19.726-7.7Z" transform="translate(-562.133 -165.188)" fill="#fff1cc"/>
                              <path d="M714.165,288.56s-22.816,11.208-32.42,28.041c0,0,31.536,20.467,31.536,18.89S714.165,288.56,714.165,288.56Z" transform="translate(-574.432 -162.772)" fill="#fff1cc"/>
                              <path d="M696.99,320.069l1.093-19.3-6.333,16.15Z" transform="translate(-564.139 -150.258)" fill="#edc8ad"/>
                              <path d="M26.682,80.687C2.674,82.177.3,102.457-.146,109.6,16.258,108.814,28.37,99.119,26.682,80.687Z" transform="translate(119.266 7.029)" fill="#2f2424"/>
                              <path d="M.011,80.687C24.019,82.177,26.4,102.457,26.84,109.6,10.435,108.814-1.678,99.119.011,80.687Z" transform="translate(179.492 7.029)" fill="#2f2424"/>
                              <ellipse cx="36.771" cy="36.838" rx="36.771" ry="36.838" transform="translate(120.133 90.807) rotate(-76.822)" fill="#2f2424"/>
                              <path d="M728.446,291.928v-11.9H709.5v11.8a43.512,43.512,0,0,0-9.458,3.266s1.658,10.079,19.377,9.449c15.855-.565,17.2-9.643,17.2-9.643A24.293,24.293,0,0,0,728.446,291.928Z" transform="translate(-555.607 -171.514)" fill="#e49980"/>
                              <path d="M725.9,266.519s3.011-4.778,9.221-2.43,3.4,17.4-5.914,19.317a7.378,7.378,0,0,1-5.956-1.555S725.538,270.737,725.9,266.519Z" transform="translate(-531.734 -188.51)" fill="#e49980"/>
                              <path d="M700.517,265.4s-3.011-4.778-9.219-2.43-3.4,17.4,5.912,19.317a7.379,7.379,0,0,0,5.956-1.555S700.876,269.622,700.517,265.4Z" transform="translate(-568.018 -189.654)" fill="#e49980"/>
                              <path d="M758.461,272.185c0,8.5-.891,26.278-6.478,36.83-5.249,9.907-13.926,15.24-25.3,15.557s-19.854-3.782-26.646-16.641-6.468-35.589-6.468-35.589,0-30.358,32.1-30.358C759.463,241.985,758.461,272.185,758.461,272.185Z" transform="translate(-562.273 -210.496)" fill="#eab292"/>
                              <path d="M705.838,265.045a2.48,2.48,0,1,1-2.482-2.474A2.48,2.48,0,0,1,705.838,265.045Z" transform="translate(-554.748 -189.402)" fill="#2f2424"/>
                              <path d="M719.888,265.045a2.48,2.48,0,1,1-2.481-2.474A2.48,2.48,0,0,1,719.888,265.045Z" transform="translate(-540.293 -189.402)" fill="#2f2424"/>
                              <path d="M708.132,266.493v2.239a3.069,3.069,0,0,0,4.015,2.948l1.769-.47" transform="translate(-547.283 -185.384)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M0,.84,18.577,5.626S18.3,2.724,10.7.837,0,.84,0,.84Z" transform="translate(169.621 58.955) rotate(8)" fill="#2f2424"/>
                              <path d="M18.578.846,0,5.631S.284,2.73,7.882.843,18.578.846,18.578.846Z" transform="translate(138.16 61.536) rotate(-8)" fill="#2f2424"/>
                              <path d="M702.673,270.982s13.137,7.149,27.34,0" transform="translate(-552.9 -180.784)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M901.245,89.9c13.363-9.566,25.307-3.427,39.389.8S957.311,118,957.311,118c-.1,0-.719,8-2.359,10.965a75.966,75.966,0,0,1,0-10.29c-22.953-3.452-37.51-11.833-42.58-21.085-4.6,10.277-13.26,17.783-24.141,22-.877,6.751-1.049,9.375-1.049,9.375C882.075,119.742,887.883,99.467,901.245,89.9Z" transform="translate(-757.391 -56.294)" fill="#2f2424"/>
                              <rect width="21.306" height="124.889" transform="translate(170.42 241.491)" fill="#e5834f"/>
                              <rect width="21.306" height="22.522" transform="translate(170.42 343.857)" fill="#e5834f"/>
                              <path d="M734.155,407.391l18.3,15.493a9.8,9.8,0,0,1,3,7.058v2.474H712.85V407.391Z" transform="translate(-542.43 -41.011)" fill="#e5834f"/>
                              <rect width="21.306" height="124.889" transform="translate(139.459 241.491)" fill="#e5834f"/>
                              <rect width="21.306" height="22.522" transform="translate(139.459 343.857)" fill="#e5834f"/>
                              <path d="M708.035,407.391l-17.943,15.493a9.791,9.791,0,0,0-3,7.058v2.474H729.7V407.391Z" transform="translate(-568.936 -41.011)" fill="#e5834f"/>
                              <path d="M709.344,327.848l-30.852,97.938s68.209,25.342,127.325-1.99l-33.784-97.272Z" transform="translate(-577.777 -123.872)" fill="#e5834f"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="center">孩子</p>
                </div>
                <div class="svgBox" @click="goParent()">
                  <div class="svgBox-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="238" height="244.289" viewBox="0 0 238 244.289">
                      <defs>
                        <clipPath id="cp2">
                          <path d="M122.49-4.726C188.212-4.726,238,55.028,238,120.587s-53.278,118.7-119,118.7S0,186.145,0,120.587C0,81.252,13.249,28.214,42.955,6.49,62.482-7.785,96.2-4.726,122.49-4.726Z" transform="translate(0 27.125)" fill="#efefef"/>
                        </clipPath>
                      </defs>
                      <g id="parent" transform="translate(0 -22.124)">
                        <path d="M118.7,0A118.7,118.7,0,1,1,0,118.7,118.7,118.7,0,0,1,118.7,0Z" transform="translate(0 29.008)" fill="#EDEDED"/>
                        <g clip-path="url(#cp2)">
                          <g id="item">
                            <g transform="translate(-70.861 26.532)">
                              <rect width="22.435" height="33.203" transform="translate(103.447 437.995)" fill="#fff"/>
                              <path d="M793.452,404.787s-27.409,1.8-26.991,21.253h56.277V404.787Z" transform="translate(-696.854 63.95)" fill="#fff"/>
                              <rect width="22.435" height="33.203" transform="translate(165.287 471.196) rotate(180)" fill="#fff"/>
                              <path d="M849.885,404.787s27.409,1.8,26.99,21.253H820.6V404.787Z" transform="translate(-677.746 63.949)" fill="#fff"/>
                              <path d="M788.436,224V458.655H819.68V246.742l6.88.07.791,211.843h31.7V224Z" transform="translate(-689.098 0.146)" fill="#fff"/>
                              <path d="M797.53,162.128l-16.406,60.4L738.109,264.12" transform="translate(-706.859 -21.692)" fill="none" stroke="#eab292" stroke-linejoin="round" stroke-width="19.648"/>
                              <circle cx="15.317" cy="15.317" r="15.317" transform="matrix(0.694, -0.72, 0.72, 0.694, 0, 244.278)" fill="#eab292"/>
                              <path d="M794.708,129.988s-11.408-.169-25.522,35.418l-7.44,21.025,45.548,3.882Z" transform="translate(-698.518 -33.035)" fill="#1a6c54"/>
                              <path d="M786.257,182.643l1.864-34.728-11.4,33.915Z" transform="translate(-693.232 -26.708)" fill="#004639"/>
                              <path d="M848.816,161.986l22.731,53.892,53.394,2.883" transform="translate(-667.787 -21.742)" fill="none" stroke="#eab292" stroke-linejoin="round" stroke-width="19.648"/>
                              <path d="M849.88,129.318s11.408-.169,25.521,35.418l7.44,21.025-45.548,3.882Z" transform="translate(-671.854 -33.272)" fill="#1a6c54"/>
                              <path d="M847.668,181.9l-.572-33.985,9.51,33.223Z" transform="translate(-668.393 -26.708)" fill="#004639"/>
                              <path d="M832.586,123.214s-16.563-1.672-44.57,9.2l-7.31,136.168h91.7L870.1,131.467S850.37,123.122,832.586,123.214Z" transform="translate(-691.826 -35.458)" fill="#1a6c54"/>
                              <path d="M820.931,143.128h0a14.679,14.679,0,0,1-14.681-14.681V109.169h29.36v19.279a14.679,14.679,0,0,1-14.68,14.68Z" transform="translate(-682.809 -40.382)" fill="#dc9c72"/>
                              <path d="M801.218,90.792s-2.433-3.518-5.32-1.812-1.967,8,0,11.154,5.145,4.705,6.9,2.288" transform="translate(-687.111 -47.672)" fill="#dc9c72"/>
                              <path d="M846.239,92.534s2.889,40.4-23.1,40.4-23.9-40.4-23.9-40.4S797.978,68.5,824.017,68.5C848.253,68.5,846.239,92.534,846.239,92.534Z" transform="translate(-685.301 -54.733)" fill="#ecb488"/>
                              <path d="M815.758,91.046v8.245a2.14,2.14,0,0,0,.153.8,2.1,2.1,0,0,0,2.507,1.162l2.165-.575" transform="translate(-679.453 -46.778)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M816.749,80.187c-.156.3-.887,3.976-.887,3.976l-12.343,1.356,3.929-2.834a9.4,9.4,0,0,1,3.294-1.327Z" transform="translate(-683.773 -50.611)" fill="#2f2424"/>
                              <path d="M819.564,80.163c.154.3.87,3.982.87,3.982l12.335,1.415-3.915-2.855a9.382,9.382,0,0,0-3.288-1.342Z" transform="translate(-678.109 -50.619)" fill="#2f2424"/>
                              <circle cx="2.155" cy="2.155" r="2.155" transform="translate(125.84 40.213)" fill="#2f2424"/>
                              <path d="M827.177,90.2a2.155,2.155,0,1,1-2.155-2.154A2.155,2.155,0,0,1,827.177,90.2Z" transform="translate(-676.943 -47.836)" fill="#2f2424"/>
                              <path d="M809.044,102.111l21.594-.52s-1.168,6.215-11.1,6.464S809.044,102.111,809.044,102.111Z" transform="translate(-681.822 -43.056)" fill="#fff"/>
                              <path d="M834.374,91.217s2.432-3.516,5.32-1.81,1.969,8,0,11.152-5.145,4.707-6.9,2.288" transform="translate(-673.441 -47.521)" fill="#dc9c72"/>
                              <path d="M829.358,58.329c-14.609.219-19.845,9.6-20.006,9.9l-.049.015c-.564-.2-8.638-2.967-12.563,5.263-3.363,7.051.552,20.057,2.012,24.358.456,1.944,1.537,4.125,2.021,5.989l1.614-15.737a13.693,13.693,0,0,1,1.81-5.1c1.17-1.916,5.83-8.454,12.586-3.926,7.386,4.948,16.024,12.481,28.475,5.805l2.063,19.883a90.385,90.385,0,0,0,2.83-10.722h0C859.4,66.337,841.583,58.146,829.358,58.329Z" transform="translate(-686.633 -58.326)" fill="#2f2424"/>
                              <path d="M911.725,166.04l34.525,1.03c-10.34-21.233-7.33-72.245-7.33-72.245l-26.7-1.139v-.043l-.508.022-.509-.022v.043l-26.442,1.139s3.793,51.012-6.549,72.245Z" transform="translate(-657.411 -41.507)" fill="#2f2424"/>
                              <path d="M886.736,407.7l-1.021-20.246h11.427v19.594Z" transform="translate(-654.764 57.835)" fill="#e5834f"/>
                              <path d="M899.675,401.94s1.266,3.911-3.8,12.171-18.137,6.083-18.137,6.083l11.808-17.6,10.407-.652" transform="translate(-657.58 62.946)" fill="#e5834f"/>
                              <path d="M882.667,418.179s-14.181,4.16-15.473,8.866h28.794l4.392-5.428,2.972,5.428h3s2.817-19.022-2.679-25.105Z" transform="translate(-661.301 62.946)" fill="#e5834f"/>
                              <path d="M926.271,407.7l1.021-20.246H915.864v19.594Z" transform="translate(-644.123 57.835)" fill="#e5834f"/>
                              <path d="M916.145,401.94s-1.265,3.911,3.8,12.171,18.138,6.083,18.138,6.083l-11.81-17.6-10.407-.652" transform="translate(-644.123 62.946)" fill="#e5834f"/>
                              <path d="M937.763,418.179s14.181,4.16,15.474,8.866H924.442l-4.393-5.428-2.971,5.428h-3s-2.817-19.022,2.677-25.105Z" transform="translate(-645.01 62.946)" fill="#e5834f"/>
                              <path d="M939.9,207.656l.191-.628H893.91s-20.343,6.232-20.184,57.24,5.723,195.668,5.723,195.668l30.509.426L914.9,251.951l2.641.188,4.938,208.223h29.146s6.927-145.086,7.085-196.094C958.841,221.353,944.465,210.136,939.9,207.656Z" transform="translate(-658.996 -5.844)" fill="#e5834f"/>
                              <path d="M944.47,251.342a11.2,11.2,0,1,0,8.38-1.834,11.2,11.2,0,0,0-8.38,1.834Z" transform="translate(-635.721 9.086)" fill="#ecb494"/>
                              <path d="M955.531,244.886l1.231,11.233-10.937-1.83-1.338-9.4Z" transform="translate(-634.018 7.515)" fill="#ecb494"/>
                              <path d="M926.579,143.324s14.567,6.1,22.246,24.247,16.4,116.579,16.4,116.579H949.872L926.721,169.5Z" transform="translate(-640.34 -28.329)" fill="#fff"/>
                              <path d="M928.995,178.023l2.814-14.985.964,33.7Z" transform="translate(-639.488 -21.371)" fill="#fff"/>
                              <path d="M895.1,140.66s-14.678,4.068-21.373,10.317l17.178,79.57h49.186l15.009-79.57s-7.061-7.524-21.354-10.589Z" transform="translate(-658.994 -29.364)" fill="#fff"/>
                              <path d="M890.562,143.324s-14.509,4.814-22.188,22.965c-5.831,13.781-9.288,43.877-10.955,61.377a8.253,8.253,0,0,0,8.223,9.035h0a8.259,8.259,0,0,0,7.976-6.111l16.859-57.244Z" transform="translate(-664.764 -28.328)" fill="#fff"/>
                              <path d="M911.5,195.964a11.406,11.406,0,1,1,3.3,15.789,11.406,11.406,0,0,1-3.3-15.789Z" transform="translate(-646.32 -11.571)" fill="#ecb494"/>
                              <path d="M905.334,207.318l11.464.93-2.176-11.076-9.6-1.091Z" transform="translate(-647.953 -9.708)" fill="#ecb494"/>
                              <path d="M864.241,193.816,924.6,193.3l-2.678,20.2-58.682,5.559Z" transform="translate(-662.697 -10.689)" fill="#fff"/>
                              <path d="M919.383,147.12V113.463H899.888V147.12l-13.078,4.229s4.527,11.853,23.1,11.438C927.128,162.4,933.027,151,933.027,151Z" transform="translate(-654.377 -38.866)" fill="#dc9c72"/>
                              <circle cx="27.214" cy="27.214" r="27.214" transform="translate(227.203 26.708)" fill="#2f2424"/>
                              <path d="M921.208,103.878a4.908,4.908,0,0,1,6.084-1.606c4.1,1.555,2.243,11.505-3.9,12.773a4.865,4.865,0,0,1-3.932-1.028S920.97,106.668,921.208,103.878Z" transform="translate(-642.855 -38.613)" fill="#dc9c72"/>
                              <path d="M888.134,103.878a4.908,4.908,0,0,0-6.084-1.606c-4.1,1.555-2.243,11.5,3.9,12.773a4.862,4.862,0,0,0,3.93-1.028S888.372,106.668,888.134,103.878Z" transform="translate(-656.83 -38.613)" fill="#dc9c72"/>
                              <path d="M886.417,107.644" transform="translate(-654.516 -36.565)" fill="none" stroke="#202020" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.416"/>
                              <path d="M882.08,104.755" transform="translate(-656.047 -37.585)" fill="none" stroke="#202020" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.416"/>
                              <path d="M933.559,102.922c0,6.376-.658,19.716-4.791,27.635-3.882,7.434-10.3,11.436-18.715,11.674s-14.685-2.838-19.708-12.488-4.784-26.7-4.784-26.7,0-22.779,23.739-22.779C934.3,80.26,933.559,102.922,933.559,102.922Z" transform="translate(-654.818 -46.23)" fill="#ecb488"/>
                              <path d="M902.048,104.054v4.336a1.818,1.818,0,0,0,.13.676,1.789,1.789,0,0,0,2.134.99l1.406-.373" transform="translate(-648.393 -36.492)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.828"/>
                              <circle cx="1.834" cy="1.834" r="1.834" transform="translate(242.801 62.693)" fill="#2f2424"/>
                              <circle cx="1.834" cy="1.834" r="1.834" transform="translate(263.406 62.858)" fill="#2f2424"/>
                              <path d="M902.88,97.3l-13.021,3.363s.591-3.652,5.918-4.979S902.88,97.3,902.88,97.3Z" transform="translate(-652.695 -39.569)" fill="#2f2424"/>
                              <path d="M905.6,97.3l13.02,3.363s-.592-3.652-5.919-4.979S905.6,97.3,905.6,97.3Z" transform="translate(-647.139 -39.569)" fill="#2f2424"/>
                              <path d="M895.795,111.894l19.773-.387s-1.027,6.131-9.752,6.317S895.795,111.894,895.795,111.894Z" transform="translate(-650.6 -33.862)" fill="#fff"/>
                              <path d="M932.964,93.278c-.192.344-.361.7-.52,1.049a19.728,19.728,0,0,0-13.418-13.119l.016-.045c-14.1-6.075-20.213-2.305-20.213-2.305-19.4,10.869-13.839,26.117-13.839,26.117h.208a15.086,15.086,0,0,0,1.385,7.421,31.686,31.686,0,0,0,2.131-7.483c15.059-.974,23.471-11.07,27.435-17.783,1.7,4.626,5.734,10.994,15.183,17.1a31.766,31.766,0,0,0,2.228,8.164C937.012,106.153,932.964,93.278,932.964,93.278Z" transform="translate(-655.281 -47.132)" fill="#2f2424"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="center">照顧者</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </transition>
      <transition name="Fade">
       <section class="l-scene" v-if="Number(step) === -1 && form.type === 'child'">
          <div class="container">
            <div class="gap-1">
              <h3 class="l-scene--title">你的性別？</h3>
              <div class="flex ai-fe l-scene--svgpanel">
                <div class="svgBox" @click="selectSex('M')">
                  <div class="svgBox-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="237.408" height="263.91" viewBox="0 0 237.408 263.91">
                      <defs>
                        <clipPath id="cp3">
                          <path d="M166.816-23.972c65.559,0,70.593,78.373,70.593,143.931A118.7,118.7,0,0,1,0,119.959C0,80.624.926,5.977,30.562-15.747,50.037-30.023,140.592-23.972,166.816-23.972Z" transform="translate(0 25.245)" fill="#efefef"/>
                        </clipPath>
                      </defs>
                      <g id="boy">
                        <circle cx="118.704" cy="118.704" r="118.704" transform="translate(0 26.501)" fill="#DCE9E5"/>
                        <g clip-path="url(#cp3)">
                          <g id="item">
                            <g transform="translate(60.702 10.847)">
                              <path d="M657.164,352.332c-1.618,6.9-9.02,11.062-16.531,9.3s-12.287-8.781-10.67-15.681,9.019-11.062,16.531-9.3S658.784,345.434,657.164,352.332Z" transform="translate(-627.781 -87.585)" fill="#eab292"/>
                              <path d="M635.652,308.194l-2.557,69.1,15.116,2.871,2.906-71.973Z" transform="translate(-623.184 -125.013)" fill="#eab292"/>
                              <path d="M655.014,286.345s-26.055,13.072-24.8,51.386c0,0,29.939,3.177,29.939,1.293S655.014,286.345,655.014,286.345Z" transform="translate(-627.08 -154.166)" fill="#fff"/>
                              <path d="M644.206,319.779l.418-18.562-7.292,18.147Z" transform="translate(-617.529 -134.322)" fill="#ddd"/>
                              <path d="M629.964,352.332c1.618,6.9,9.02,11.062,16.531,9.3s12.287-8.781,10.67-15.681-9.019-11.062-16.531-9.3S628.344,345.434,629.964,352.332Z" transform="translate(-535.494 -88.736)" fill="#eab292"/>
                              <path d="M648.56,308.194l2.557,69.1L636,380.167l-2.906-71.973Z" transform="translate(-537.178 -126.164)" fill="#eab292"/>
                              <path d="M635.315,286.345s26.055,13.072,24.8,51.386c0,0-29.939,3.177-29.939,1.293S635.315,286.345,635.315,286.345Z" transform="translate(-539.396 -155.316)" fill="#fff"/>
                              <path d="M637.75,319.779l-.418-18.562,7.292,18.147Z" transform="translate(-540.574 -135.473)" fill="#ddd"/>
                              <path d="M665.779,282.239s-8.613.509-23.574,9.587l-2.432,96.717,72.453,1.578-1.932-99.42s-14.5-8.576-22.72-8.462Z" transform="translate(-614.273 -159.646)" fill="#fff"/>
                              <path d="M641.329,327.779,638.6,514.336H671.06l7.174-168.588,3.223,168.588H713.91l-.126-184.977Z" transform="translate(-615.832 -98.883)" fill="#1a6c54"/>
                              <path d="M651.623,407.7l-10.576,10.208h0c-9.736,6.1-11.748,11.641-12.115,14.279h-.044v.313a5.19,5.19,0,0,0,0,1.319v3.751h55.189V407.7Z" transform="translate(-628.848 7.752)" fill="#1a6c54"/>
                              <path d="M712.152,432.5v-.313h-.044c-.366-2.638-2.379-8.175-12.115-14.279L689.416,407.7H656.963v29.869h55.189v-3.751a5.191,5.191,0,0,0,0-1.318Z" transform="translate(-591.338 7.752)" fill="#1a6c54"/>
                              <circle cx="43.698" cy="43.698" r="43.698" transform="translate(3.797 40.762) rotate(-27.801)" fill="#2f2424"/>
                              <rect id="Rectangle_1276" data-name="Rectangle 1276" width="21.796" height="26.155" rx="7" transform="translate(51.504 108.919)" fill="#e49980"/>
                              <path d="M672.507,262.518s3.464-5.509,10.607-2.8,3.912,20.058-6.8,22.269a8.476,8.476,0,0,1-6.853-1.793S672.091,267.381,672.507,262.518Z" transform="translate(-574.67 -183.019)" fill="#e49980"/>
                              <path d="M648.613,261.4s-3.464-5.509-10.607-2.8-3.912,20.058,6.8,22.269a8.477,8.477,0,0,0,6.853-1.793S649.029,266.266,648.613,261.4Z" transform="translate(-621.723 -184.505)" fill="#e49980"/>
                              <path d="M714.439,272.332c0,9.8-1.022,30.3-7.453,42.462-6.036,11.424-16.02,17.57-29.11,17.936s-22.843-4.36-30.658-19.185-7.442-41.032-7.442-41.032,0-35,36.926-35C715.594,237.514,714.439,272.332,714.439,272.332Z" transform="translate(-614.275 -211.645)" fill="#eab292"/>
                              <circle cx="2.853" cy="2.853" r="2.853" transform="translate(42.57 73.921)" fill="#2f2424"/>
                              <circle cx="2.853" cy="2.853" r="2.853" transform="translate(75.367 73.921)" fill="#2f2424"/>
                              <path d="M654.342,262.022V264.6a3.735,3.735,0,0,0,.264,1.382A3.651,3.651,0,0,0,658.959,268l2.038-.541" transform="translate(-594.836 -178.945)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M658.428,253.957,679.8,259.48s-.971-6-9.715-8.175S658.428,253.957,658.428,253.957Z" transform="translate(-589.383 -193.999)" fill="#2f2424"/>
                              <path d="M664.955,253.957,643.58,259.48s.971-6,9.715-8.175S664.955,253.957,664.955,253.957Z" transform="translate(-609.195 -193.999)" fill="#2f2424"/>
                              <path d="M649.688,267H677.37s-1.713,8.786-13.924,8.786S649.688,267,649.688,267Z" transform="translate(-601.045 -172.299)" fill="#fff"/>
                              <path d="M634.679,240.929c-.021-.021-.044-.04-.065-.063C634.614,240.866,634.64,240.894,634.679,240.929Z" transform="translate(-621.156 -207.173)" fill="#331b23"/>
                              <path d="M701.533,247.415c-6.867-2.47-11.256-3.634-14.02-4.02a9.114,9.114,0,0,0-3.261,0l-.107.016c-.119-.04-.24-.077-.36-.114a8.319,8.319,0,0,0,.037-4.209c-1.914-7.694-9.087-8.917-12.986-8.994a8.488,8.488,0,0,0-5.936,2.26,10.717,10.717,0,0,0-3.3,5.773,39.236,39.236,0,0,0-12.467-2,18.435,18.435,0,0,0-9.591,2.39c-7.33,4.309-6.267,10.894-5.061,14.307a7.037,7.037,0,0,0,1.6,2.54A.7.7,0,0,1,636,255.3a37.253,37.253,0,0,0,14.064,9.043,45.754,45.754,0,0,0-5.637,20.6c9.155-2.768,12.626-11.881,13.947-18.188,21.494,4.51,47.135-1.541,54.439-3.49.691,5.716,3.452,18.328,14.524,21.678C727.338,284.95,727.658,256.813,701.533,247.415Zm10.5,12.736.548.257s0,.079.007.222c-.175-.152-.369-.316-.558-.479Z" transform="translate(-622.479 -221.546)" fill="#2f2424"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="center">男孩</p>
                </div>
                <div class="svgBox" @click="selectSex('F')">
                  <div class="svgBox-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="237.408" height="263.91" viewBox="0 0 237.408 263.91">
                      <defs>
                        <clipPath id="cp4">
                          <path d="M166.816-23.972c65.559,0,70.593,78.373,70.593,143.931A118.7,118.7,0,0,1,0,119.959C0,80.624.926,5.977,30.562-15.747,50.037-30.023,140.592-23.972,166.816-23.972Z" transform="translate(0 25.245)" fill="#efefef"/>
                        </clipPath>
                      </defs>
                      <g id="girl" transform="translate(0 0)">
                        <circle cx="118.704" cy="118.704" r="118.704" transform="translate(0 26.501)" fill="#EDEDED"/>
                        <g clip-path="url(#cp4)">
                          <g id="item" >
                            <g transform="translate(42.942 7.86)">
                              <path d="M721.372,354.468c1.618,6.9,9.026,11.072,16.545,9.309s12.3-8.791,10.677-15.693-9.026-11.072-16.542-9.309S719.752,347.566,721.372,354.468Z" transform="translate(-618.115 -80.242)" fill="#e0a396"/>
                              <path d="M739.068,311.275l2.558,69.156L726.5,383.3l-2.908-72.029Z" transform="translate(-614.52 -118.676)" fill="#e0a396"/>
                              <path d="M726.609,290.17s26.073,13.084,24.818,51.426c0,0-29.965,3.18-29.965,1.294S726.609,290.17,726.609,290.17Z" transform="translate(-617.537 -148.612)" fill="#fff1cc"/>
                              <path d="M724.7,324.782l-.85-21.424,7.031,21.041Z" transform="translate(-614.15 -129.906)" fill="#edc8ad"/>
                              <path d="M748.595,354.468c-1.618,6.9-9.026,11.072-16.545,9.309s-12.3-8.791-10.678-15.693,9.026-11.072,16.543-9.309S750.215,347.566,748.595,354.468Z" transform="translate(-701.975 -81.242)" fill="#e0a396"/>
                              <path d="M726.149,311.275l-2.559,69.156,15.128,2.873,2.908-72.029Z" transform="translate(-700.822 -119.676)" fill="#e0a396"/>
                              <path d="M746.326,290.17s-26.074,13.084-24.819,51.426c0,0,29.965,3.18,29.965,1.294S746.326,290.17,746.326,290.17Z" transform="translate(-705.52 -149.612)" fill="#fff1cc"/>
                              <path d="M730.032,324.782l.85-21.424L723.85,324.4Z" transform="translate(-690.701 -130.906)" fill="#edc8ad"/>
                              <path d="M742.4,286.2s8.622.508,23.592,9.594l2.435,87.92L693.7,385.3l3.374-89.9s15.29-9.313,23.515-9.2Z" transform="translate(-656.922 -154.24)" fill="#fff1cc"/>
                              <path d="M31.834,80.687c-28.618,1.78-31.45,26-31.98,34.535C19.408,114.284,33.847,102.7,31.834,80.687Z" transform="translate(22.088 11.502)" fill="#2f2424"/>
                              <path d="M.041,80.687c28.619,1.781,31.452,26,31.982,34.535C12.467,114.284-1.972,102.7.041,80.687Z" transform="translate(93.879 11.502)" fill="#2f2424"/>
                              <circle cx="43.898" cy="43.898" r="43.898" transform="translate(23.148 95.879) rotate(-76.822)" fill="#2f2424"/>
                              <path d="M733.9,294.242V280.029H711.317v14.1a51.8,51.8,0,0,0-11.275,3.9s1.976,12.039,23.1,11.287c18.9-.675,20.5-11.519,20.5-11.519a28.924,28.924,0,0,0-9.742-3.555Z" transform="translate(-647.924 -162.996)" fill="#e49980"/>
                              <path d="M726.406,267.118s3.589-5.707,10.992-2.9,4.051,20.782-7.05,23.074a8.781,8.781,0,0,1-7.1-1.857S725.977,272.156,726.406,267.118Z" transform="translate(-615.008 -186.526)" fill="#e49980"/>
                              <path d="M702.925,266s-3.589-5.708-10.989-2.9-4.053,20.784,7.047,23.075a8.781,8.781,0,0,0,7.1-1.857S703.353,271.041,702.925,266Z" transform="translate(-665.031 -188.107)" fill="#e49980"/>
                              <path d="M770.925,278.059c0,10.15-1.062,31.389-7.722,43.994-6.257,11.833-16.6,18.2-30.163,18.583s-23.667-4.518-31.764-19.877-7.71-42.511-7.71-42.511,0-36.262,38.26-36.262C772.12,241.985,770.925,278.059,770.925,278.059Z" transform="translate(-657.113 -216.96)" fill="#eab292"/>
                              <path d="M706.79,265.526a2.957,2.957,0,1,1-2.958-2.955,2.957,2.957,0,0,1,2.958,2.955Z" transform="translate(-646.738 -187.759)" fill="#2f2424"/>
                              <path d="M720.84,265.526a2.957,2.957,0,1,1-2.958-2.955,2.957,2.957,0,0,1,2.958,2.955Z" transform="translate(-626.809 -187.759)" fill="#2f2424"/>
                              <path d="M708.132,266.493v2.675a3.663,3.663,0,0,0,4.786,3.521l2.109-.561" transform="translate(-636.447 -182.196)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M0,1,22.148,6.726S21.811,3.26,12.751,1,0,1,0,1Z" transform="translate(82.143 57.832) rotate(8)" fill="#2f2424"/>
                              <path d="M22.147,1,0,6.726S.337,3.26,9.4,1,22.147,1,22.147,1Z" transform="translate(44.637 60.915) rotate(-8)" fill="#2f2424"/>
                              <path d="M702.673,270.982s15.659,8.54,32.591,0" transform="translate(-644.191 -175.829)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M904.3,90.887c15.929-11.427,30.167-4.093,46.953.957s19.88,32.609,19.88,32.609c-.124,0-.857,9.56-2.812,13.1a90.922,90.922,0,0,1,0-12.292c-27.361-4.123-44.713-14.134-50.757-25.186-5.488,12.276-15.807,21.242-28.777,26.279-1.045,8.064-1.25,11.2-1.25,11.2C881.446,126.532,888.37,102.314,904.3,90.887Z" transform="translate(-852.873 -63.333)" fill="#2f2424"/>
                              <rect width="25.398" height="149.18" transform="translate(83.092 275.872)" fill="#e5834f"/>
                              <rect width="25.398" height="26.903" transform="translate(83.092 398.149)" fill="#e5834f"/>
                              <path d="M738.246,407.391,760.065,425.9a11.715,11.715,0,0,1,3.579,8.431v2.956H712.85v-29.9Z" transform="translate(-629.756 17.661)" fill="#e5834f"/>
                              <rect width="25.398" height="149.18" transform="translate(46.186 275.872)" fill="#e5834f"/>
                              <rect width="25.398" height="26.903" transform="translate(46.186 398.149)" fill="#e5834f"/>
                              <path d="M712.058,407.391,690.669,425.9a11.707,11.707,0,0,0-3.582,8.431v2.956h50.8v-29.9Z" transform="translate(-666.299 17.661)" fill="#e5834f"/>
                              <path d="M715.269,328.106,678.492,445.094s81.308,30.272,151.777-2.377L790,326.524Z" transform="translate(-678.492 -97.045)" fill="#e5834f"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="center">女孩</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </transition>
      <transition name="Fade">
       <section class="l-scene" v-if="Number(step) === -1 && form.type === 'parent'">
          <div class="container">
            <div class="gap-1">
              <h3 class="l-scene--title">你的性別？</h3>
              <div class="flex ai-fe l-scene--svgpanel">
                <div class="svgBox" @click="selectSex('M')">
                  <div class="svgBox-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="237.408" height="266.417" viewBox="0 0 237.408 266.417">
                      <defs>
                        <clipPath id="cp5">
                          <path d="M137.488-23.85c65.559,0,99.921,78.879,99.921,144.437A118.7,118.7,0,0,1,0,120.587C0,81.252,23.835,2.358,53.47-19.366,72.946-33.641,111.264-23.85,137.488-23.85Z" transform="translate(0 27.125)" fill="#efefef"/>
                        </clipPath>
                      </defs>
                      <g id="male">
                        <circle cx="118.704" cy="118.704" r="118.704" transform="translate(0 29.008)" fill="#DCE9E5"/>
                        <g clip-path="url(#cp5)">
                          <g id="item">
                            <g transform="translate(-40.161 10.999)">
                              <rect width="25.964" height="38.425" transform="translate(119.715 506.881)" fill="#fff"/>
                              <path d="M797.7,404.787s-31.72,2.079-31.236,24.6H831.59v-24.6Z" transform="translate(-685.91 137.673)" fill="#fff"/>
                              <rect width="25.964" height="38.425" transform="translate(191.279 545.306) rotate(180)" fill="#fff"/>
                              <path d="M854.491,404.787s31.72,2.079,31.235,24.6H820.6v-24.6Z" transform="translate(-655.283 137.673)" fill="#fff"/>
                              <path d="M788.436,224V495.56h36.159V250.318l7.962.081.916,245.161h36.682V224Z" transform="translate(-673.477 35.401)" fill="#fff"/>
                              <path d="M806.876,162.128l-18.987,69.9-49.78,48.133" transform="translate(-701.945 0.397)" fill="none" stroke="#eab292" stroke-linejoin="round" stroke-width="19.648"/>
                              <circle cx="17.726" cy="17.726" r="17.726" transform="matrix(0.694, -0.72, 0.72, 0.694, 0, 282.699)" fill="#eab292"/>
                              <path d="M799.892,129.988s-13.2-.2-29.536,40.989l-8.61,24.331,52.711,4.492Z" transform="translate(-688.574 -17.785)" fill="#1a6c54"/>
                              <path d="M787.757,188.1l2.157-40.19-13.2,39.249Z" transform="translate(-680.105 -7.643)" fill="#004639"/>
                              <path d="M738.109,162.128l18.986,69.9,49.78,48.133" transform="translate(-525.309 -0.759)" fill="none" stroke="#eab292" stroke-linejoin="round" stroke-width="19.648"/>
                              <circle cx="17.725" cy="17.725" r="17.725" transform="matrix(-0.694, -0.72, 0.72, -0.694, 292.219, 306.157)" fill="#eab292"/>
                              <path d="M776.311,129.988s13.2-.2,29.536,40.989l8.61,24.331L761.746,199.8Z" transform="translate(-569.898 -18.942)" fill="#1a6c54"/>
                              <path d="M778.875,188.1l-2.157-40.19,13.2,39.249Z" transform="translate(-568.799 -8.8)" fill="#004639"/>
                              <path d="M840.745,123.229s-19.167-1.935-51.58,10.644l-8.459,157.585H886.833L884.165,132.78S861.326,123.122,840.745,123.229Z" transform="translate(-677.848 -21.67)" fill="#1a6c54"/>
                              <path d="M823.24,148.468h0a16.988,16.988,0,0,1-16.99-16.99V109.169h33.978V131.48A16.988,16.988,0,0,1,823.24,148.468Z" transform="translate(-663.398 -29.563)" fill="#dc9c72"/>
                              <path d="M802.343,91.151s-2.815-4.071-6.156-2.1-2.276,9.263,0,12.908,5.955,5.446,7.988,2.648" transform="translate(-670.293 -41.248)" fill="#dc9c72"/>
                              <path d="M853.638,96.314s3.343,46.757-26.735,46.757-27.665-46.757-27.665-46.757S797.787,68.5,827.921,68.5C855.969,68.5,853.638,96.314,853.638,96.314Z" transform="translate(-667.391 -52.567)" fill="#ecb488"/>
                              <path d="M815.758,91.046v9.541a2.478,2.478,0,0,0,.177.921,2.432,2.432,0,0,0,2.9,1.345l2.5-.665" transform="translate(-658.02 -39.815)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.798"/>
                              <path d="M818.83,80.187c-.18.348-1.027,4.6-1.027,4.6l-14.284,1.569,4.547-3.28a10.873,10.873,0,0,1,3.813-1.536Z" transform="translate(-664.943 -45.958)" fill="#2f2424"/>
                              <path d="M819.564,80.163c.178.349,1.007,4.608,1.007,4.608l14.275,1.638-4.531-3.3a10.858,10.858,0,0,0-3.8-1.553Z" transform="translate(-655.867 -45.972)" fill="#2f2424"/>
                              <circle cx="2.494" cy="2.494" r="2.494" transform="translate(145.629 46.537)" fill="#2f2424"/>
                              <path d="M827.855,90.542a2.494,2.494,0,1,1-2.494-2.493,2.494,2.494,0,0,1,2.494,2.493Z" transform="translate(-653.998 -41.511)" fill="#2f2424"/>
                              <path d="M809.044,102.192l24.99-.6s-1.351,7.193-12.842,7.481S809.044,102.192,809.044,102.192Z" transform="translate(-661.818 -33.85)" fill="#fff"/>
                              <path d="M834.623,91.575s2.815-4.069,6.156-2.1,2.278,9.263,0,12.906-5.954,5.447-7.988,2.648" transform="translate(-648.383 -41.007)" fill="#dc9c72"/>
                              <path d="M834.7,58.329c-16.907.254-22.966,11.112-23.152,11.453l-.056.017c-.653-.236-10-3.434-14.539,6.091-3.892,8.161.639,23.212,2.328,28.189.528,2.25,1.779,4.774,2.339,6.931l1.864-18.21a15.849,15.849,0,0,1,2.095-5.9c1.354-2.217,6.747-9.784,14.566-4.544,8.547,5.726,18.544,14.444,32.954,6.718l2.388,23.01a104.6,104.6,0,0,0,3.276-12.408h0C869.463,67.6,848.845,58.118,834.7,58.329Z" transform="translate(-669.529 -58.326)" fill="#2f2424"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="center">男</p>
                </div>
                <div class="svgBox" @click="selectSex('F')">
                  <div class="svgBox-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="237.408" height="266.417" viewBox="0 0 237.408 266.417">
                      <defs>
                        <clipPath id="cp6">
                          <path d="M137.488-23.85c65.559,0,99.921,78.879,99.921,144.437A118.7,118.7,0,0,1,0,120.587C0,81.252,23.835,2.358,53.47-19.366,72.946-33.641,111.264-23.85,137.488-23.85Z" transform="translate(0 27.125)" fill="#efefef"/>
                        </clipPath>
                      </defs>
                      <g id="female">
                        <circle cx="118.704" cy="118.704" r="118.704" transform="translate(0 29.008)" fill="#EDEDED"/>
                        <g clip-path="url(#cp6)">
                          <g id="item">
                            <g transform="translate(-149.081 -18.728)">
                              <path d="M918.851,181.436l41.867,1.249c-12.539-25.748-8.889-87.608-8.889-87.608L919.457,93.7v-.053l-.617.026-.617-.026V93.7l-32.065,1.381s4.6,61.86-7.942,87.608Z" transform="translate(-651.416 -36.1)" fill="#2f2424"/>
                              <path d="M886.953,412.009l-1.238-24.552h13.858v23.761Z" transform="translate(-646.615 146.848)" fill="#e5834f"/>
                              <path d="M904.339,401.94s1.535,4.743-4.6,14.759-21.994,7.376-21.994,7.376l14.319-21.345,12.62-.791" transform="translate(-651.723 156.127)" fill="#e5834f"/>
                              <path d="M885.958,421.633s-17.2,5.045-18.764,10.751h34.918l5.326-6.582,3.6,6.582h3.644s3.416-23.067-3.248-30.444Z" transform="translate(-658.48 156.127)" fill="#e5834f"/>
                              <path d="M928.484,412.009l1.238-24.552H915.864v23.761Z" transform="translate(-627.299 146.848)" fill="#e5834f"/>
                              <path d="M916.205,401.94s-1.534,4.743,4.6,14.759,21.995,7.376,21.995,7.376L928.484,402.73l-12.62-.791" transform="translate(-627.299 156.127)" fill="#e5834f"/>
                              <path d="M942.954,421.633s17.2,5.045,18.764,10.751H926.8l-5.327-6.582-3.6,6.582h-3.644s-3.416-23.067,3.247-30.444Z" transform="translate(-628.908 156.127)" fill="#e5834f"/>
                              <path d="M953.971,207.789l.232-.761h-56s-24.669,7.557-24.477,69.412,6.94,237.277,6.94,237.277l37,.517,5.992-252.73,3.2.228,5.988,252.5H968.19s8.4-175.939,8.592-237.794C976.941,224.4,959.508,210.8,953.971,207.789Z" transform="translate(-654.295 31.259)" fill="#e5834f"/>
                              <path d="M945.493,251.769a13.588,13.588,0,1,0,18.913,3.4,13.588,13.588,0,0,0-18.913-3.4Z" transform="translate(-612.057 58.364)" fill="#ecb494"/>
                              <path d="M957.88,244.886l1.492,13.621-13.263-2.219-1.622-11.4Z" transform="translate(-608.965 55.512)" fill="#ecb494"/>
                              <path d="M926.579,143.324s17.665,7.393,26.977,29.4S973.449,314.1,973.449,314.1H954.826L926.751,175.065Z" transform="translate(-620.438 -9.552)" fill="#fff"/>
                              <path d="M928.995,181.21l3.413-18.171,1.168,40.86Z" transform="translate(-618.889 3.078)" fill="#fff"/>
                              <path d="M899.644,140.718s-17.8,4.933-25.919,12.511l20.831,96.491H954.2l18.2-96.491s-8.563-9.124-25.894-12.841Z" transform="translate(-654.297 -11.433)" fill="#fff"/>
                              <path d="M897.618,143.324s-17.594,5.837-26.907,27.848c-7.071,16.712-11.263,53.207-13.284,74.429a10.009,10.009,0,0,0,9.972,10.956h0a10.016,10.016,0,0,0,9.672-7.41l20.444-69.418Z" transform="translate(-664.768 -9.552)" fill="#fff"/>
                              <path d="M911.9,197.061a13.831,13.831,0,1,1,4,19.146,13.831,13.831,0,0,1-4-19.146Z" transform="translate(-631.289 20.864)" fill="#ecb494"/>
                              <path d="M905.4,209.708l13.9,1.127L916.665,197.4l-11.648-1.323Z" transform="translate(-634.25 24.246)" fill="#ecb494"/>
                              <path d="M864.454,193.925l73.191-.624L934.4,217.8l-71.161,6.741Z" transform="translate(-661.016 22.465)" fill="#fff"/>
                              <path d="M926.31,154.277V113.463H902.67v40.814l-15.859,5.129s5.49,14.374,28.009,13.87c20.882-.466,28.035-14.295,28.035-14.295Z" transform="translate(-645.91 -28.682)" fill="#dc9c72"/>
                              <circle cx="33.001" cy="33.001" r="33.001" transform="translate(234.557 26.708)" fill="#2f2424"/>
                              <path d="M921.58,104.311s2.408-3.831,7.378-1.947,2.72,13.952-4.732,15.489a5.9,5.9,0,0,1-4.768-1.247S921.291,107.694,921.58,104.311Z" transform="translate(-624.996 -30.846)" fill="#dc9c72"/>
                              <path d="M889.893,104.311s-2.408-3.831-7.378-1.947-2.72,13.952,4.734,15.489a5.9,5.9,0,0,0,4.766-1.247S890.182,107.694,889.893,104.311Z" transform="translate(-650.365 -30.846)" fill="#dc9c72"/>
                              <path d="M886.417,107.644" transform="translate(-646.166 -27.129)" fill="none" stroke="#202020" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.416"/>
                              <path d="M882.08,104.755" transform="translate(-648.943 -28.98)" fill="none" stroke="#202020" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.416"/>
                              <path d="M943.767,107.741c0,7.732-.8,23.909-5.81,33.512-4.707,9.015-12.49,13.868-22.7,14.157s-17.808-3.442-23.9-15.143-5.8-32.383-5.8-32.383,0-27.623,28.787-27.623C944.667,80.26,943.767,107.741,943.767,107.741Z" transform="translate(-646.713 -44.672)" fill="#ecb488"/>
                              <path d="M902.048,104.054v5.258a2.205,2.205,0,0,0,.157.82,2.17,2.17,0,0,0,2.587,1.2l1.7-.453" transform="translate(-635.414 -27.803)" fill="none" stroke="#683e2f" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.828"/>
                              <circle cx="2.224" cy="2.224" r="2.224" transform="translate(253.471 70.347)" fill="#2f2424"/>
                              <circle cx="2.224" cy="2.224" r="2.224" transform="translate(278.457 70.548)" fill="#2f2424"/>
                              <path d="M905.649,97.712l-15.79,4.079s.717-4.428,7.176-6.038S905.649,97.712,905.649,97.712Z" transform="translate(-643.223 -33.388)" fill="#2f2424"/>
                              <path d="M905.6,97.712l15.789,4.079s-.719-4.428-7.178-6.038S905.6,97.712,905.6,97.712Z" transform="translate(-633.141 -33.388)" fill="#2f2424"/>
                              <path d="M895.795,111.976l23.978-.469s-1.245,7.435-11.826,7.66S895.795,111.976,895.795,111.976Z" transform="translate(-639.42 -23.028)" fill="#fff"/>
                              <path d="M943.323,96.591c-.233.417-.438.843-.63,1.271-2.2-6.361-6.789-13.084-16.272-15.909l.02-.054c-17.1-7.366-24.511-2.8-24.511-2.8-23.522,13.181-16.782,31.671-16.782,31.671h.253c-.067,3.308.336,6.567,1.68,9a38.422,38.422,0,0,0,2.584-9.074c18.262-1.181,28.462-13.424,33.269-21.565,2.059,5.609,6.953,13.332,18.411,20.739a38.519,38.519,0,0,0,2.7,9.9C948.231,112.2,943.323,96.591,943.323,96.591Z" transform="translate(-647.551 -46.311)" fill="#2f2424"/>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="center">女</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </transition>
      <transition name="Fade">
       <section class="l-scene" v-if="Number(step) === 0">
          <div class="container">
            <div class="gap-3 col-5">
              <h3 class="l-scene--title">你的年齡是？</h3>
              <div class="formBox l-scene--paragraph">
                <input class="l-scene--input type-2" type="number" id="age" v-model="form.age" min="0" max="100" step="1">
                <p class="formBox--error" v-if="errorMsg" v-html="msgContent"></p>
              </div>
              <Btn type="green" @click.native="selectAge()" class="l-scene--btn">確認</Btn>
            </div>
          </div>
        </section>
      </transition>
      <!-- 題目區 開始 -->
      <transition v-for="(item , key) in source" :key="key" name="Fade-Question">
       <section class="l-scene" v-if="Number(step) === (key + 1)">
          <div class="container h-100">
            <div class="flex fd-c h-100">
              <div class="flex--gap" v-if="Number(step) < 7"></div>
              <h3 class="l-scene--title center gap-0">{{ item.title }}</h3>
              <ul ref="answerBar" class="m-answer relative mx-auto" :class="'step_'+step">
                <li class="relative center" v-for="(subitem, subkey) in item.ans" :key="subkey">
                    <p>{{ subitem.sub_title }}</p>
                </li>
              </ul>
              <QuestionType1 :keys="key" v-if="key < 3" />
              <QuestionType2 :keys="key" v-if="key >= 3 && key < 6" />
              <QuestionType3 :keys="key" v-if="key >=6"/>
              <QuestionType4 :keys="key" />
              <div class="btnBox flex jc-c">
                <Btn type="white" @click.native="goPrev()" v-if="key > 0">回上一題</Btn>
                <Btn type="green" @click.native="checkGoNext(key)" v-if="source.length === (key + 1)">看解答</Btn>
                <Btn type="white" @click.native="checkGoNext(key)" v-else>下一題</Btn>
                <p class="btnBox--info" v-if="errorMsg">選擇後才能進入下一題哦！</p>
              </div>
            </div>
          </div>
        </section>
      </transition>
      <!-- 題目區 結束 -->
      <transition>
       <section class="l-scene" v-if="Number(step) === 12">
          <div class="container">
            <div class="flex flex-wrap jc-fe">
              <Form :id="form.id" />
              <Result :score="score" :type="form.type" />
            </div>
          </div>
        </section>
      </transition>
      <Lightbox :type="form.type" :policy="isPolicy" :status="isLightbox"/>
      <div class="scenecontrol" :class="'step_'+step">
        <Grasscontrol :total="grassTotal + 1" :step="step + 3"/>
      </div>
    </div>
  </main>
</template>

<script>
import Btn from './components/Btn.vue'
import Ccfwawa from './components/Ccfwawa.vue'
import Form from './components/Form.vue'
import Grasscontrol from './components/Grasscontrol.vue'
import Lightbox from './components/Lightbox.vue'
import Result from './components/Result.vue'
import Counter from './components/Counter.vue'
import QuestionType1 from './components/QuestionType1.vue'
import QuestionType2 from './components/QuestionType2.vue'
import QuestionType3 from './components/QuestionType3.vue'
import QuestionType4 from './components/QuestionType4.vue'
import source from './json/question.json'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'App',
  components: {
    Btn,
    Ccfwawa,
    Form,
    Result,
    Lightbox,
    QuestionType1,
    QuestionType2,
    QuestionType3,
    QuestionType4,
    Grasscontrol,
    Counter
  },
  data () {
    return {
      source,
      errorMsg: false,
      msgContent: '年齡必填哦！',
      isLightbox: false,
      total: 11,
      step: -3, // -3 ~ 12
      score: null, // 最終分數
      GOOGLE_SHEETS_SUBSCRIBE: 'AKfycbx3YIO9N4jvhWpNhYpgLhJhLuNHYEpHEWqbDt5RiaivGGHaIQvga2chhDC5_o-dyGRP',
      form: {
        id: null, // 作為寫入google表單時產生的timestamp依據
        nickname: '',
        type: null, // 'child' or 'parent'
        age: null, // number
        sex: null, // 'M' or 'F'
        res: [ // 搜集各題目分數 之後要寫入google表單 不紀錄選項
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null },
          { score: null }
        ]
      },
      isPolicy: false
    }
  },
  computed: {
    grassTotal () {
      return this.total + 4
    }
  },
  watch: {
    'form.nickname': {
      handler: function () {
        if (this.form.nickname) {
          this.errorMsg = false
        } else {
          this.errorMsg = true
        }
      }
    },
    'form.age': {
      handler: function () {
        if (isNaN(parseInt(this.form.age))) {
          this.errorMsg = true
          this.msgContent = '年齡必填哦！'
        } else if (parseInt(this.form.age) <= 0 || parseInt(this.form.age) > 100) {
          this.errorMsg = true
          this.msgContent = '年齡需介於1~100哦！'
        } else {
          this.errorMsg = false
        }
      }
    }
  },
  methods: {
    sendResult () {
      this.form.res_1 = this.form.res[0].score
      this.form.res_2 = this.form.res[1].score
      this.form.res_3 = this.form.res[2].score
      this.form.res_4 = this.form.res[3].score
      this.form.res_5 = this.form.res[4].score
      this.form.res_6 = this.form.res[5].score
      this.form.res_7 = this.form.res[6].score
      this.form.res_8 = this.form.res[7].score
      this.form.res_9 = this.form.res[8].score
      this.form.res_10 = this.form.res[9].score
      this.form.res_11 = this.form.res[10].score
      const time = new Date()
      this.form.id = `N${time.getTime()}`
      this.form.timestamp = time.toString()
      axios.post(`https://script.google.com/macros/s/${this.GOOGLE_SHEETS_SUBSCRIBE}/exec`, qs.stringify(this.form))
        .then((res) => {
          console.log(res.status)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    goPrev () {
      this.step--
    },
    goNext () {
      this.step++
    },
    checkGoNext (e) {
      if (this.form.res[e].score != null) {
        if (e === 10) {
          this.doFinalStep()
        }
        this.step++
        this.errorMsg = false
      } else {
        this.errorMsg = true
      }
    },
    selectNicename () {
      if (this.form.nickname) {
        this.goNext()
      } else {
        this.errorMsg = true
      }
    },
    selectAge () {
      if (isNaN(parseInt(this.form.age)) || parseInt(this.form.age) <= 0 || parseInt(this.form.age) > 100) {
        this.errorMsg = true
      } else {
        this.goNext()
      }
    },
    selectSex (e) {
      this.form.sex = e
      this.goNext()
    },
    doFinalStep () {
      this.countScore()
      this.sendResult()
    },
    goChild () {
      this.form.type = 'child'
      this.source = this.source.child
    },
    goParent () {
      this.form.type = 'parent'
      this.source = this.source.parent
    },
    selectAns (key, value) {
      this.form.res[key].score = value
    },
    countScore () {
      let sum = 0
      for (let i = 0; i < this.form.res.length; i += 1) {
        sum += Number(this.form.res[i].score)
      }
      this.score = sum
      this.form.score = sum
    }
  }
}
</script>

<style lang="scss">
 #app {
  color: $color-primary;
 }
.logo{
  width: 200px;
}
.m-ccfwawa {
  &.step_4{
    .m-dialog {
      display: none;
      @include respond-to('1200') {
        display: inline-block;
      }
    }
  }
}
.m-answer {
 @include respond-to('1200') {
   &.step_1,
   &.step_2,
   &.step_3{
    transform: translate3d(0, 25px, 0);
    &:before{
        content: '';
        position: absolute;
        top: 3px;
        left: 30px;
        height: 21px;
        width: 18px;
        background: url(~@/assets/ans-arrow.svg)center center/ cover no-repeat;
    }
    &:after{
      content: '';
      position: absolute;
      top: 3px;
      right: 30px;
      height: 21px;
      width: 18px;
      background: url(~@/assets/ans-arrow.svg)center center/ cover no-repeat;
      transform: rotate(180deg);
    }
  }
 }
}
.l-scene{
  position: absolute;
  top: 0;
  left: 0;
  height: 600px;
  @include respond-to(sm) {
    height: 800px;
  }
  @include respond-to(md) {
    height: 900px;
  }
  @include respond-to('1200') {
    height: 100vh;
  }
  width: 100vw;
  &--monster{
    display: none;
    &-1{
      animation: loop 7.5s ease-in-out infinite alternate;
    }
    &-2{
      animation: loop 6s .4s ease-in-out infinite alternate;
    }
    &-3{
      animation: loop 5.5s .5s ease-in-out infinite alternate;
    }
    &-4{
      animation: loop 8s .3s ease-in-out infinite alternate;
    }
  }
  &--paragraph{
    padding-bottom: 30px;
    max-width: 400px;
  }
  &--btn,
  &--title,
  &--input,
  &--svgpanel,
  &--paragraph{
    position: relative;
    z-index: map-get($z, 'c-h');
  }
    @include respond-to(md) {
      &--monster{
        display: block;
        position: absolute;
        z-index: -1;
        bottom: 5%;
        left: 5%;
        transform: scale(0.6);
      }
    }
   @include respond-to('1200') {
    min-height: 768px;
    &--monster{
      transform: scale(0.8)
    }
    &--paragraph{
      padding-bottom: 50px;
      max-width: none;
    }
   }
    @include respond-to(xl) {
      &--monster{
        bottom: 12.5%;
        left: 20%;
        transform: scale(1)
      }
    }
}
.scenecontrol{
  &.step_-3,
  &.step_-1,
  &.step_1,
  &.step_3,
  &.step_5,
  &.step_7,
  &.step_9,
  &.step_11{
    .grass1-3__willow{
      animation: rx-1 3s 1s 3 alternate;
    }
    .grass1-1__leaf1{
      animation: rx-1 2.6s 1.5s 2 alternate;
    }
    .grass2-1__bush{
      animation: tx-1 1.3s 2s 2 alternate;
    }
    .grass1-2__leaf1{
      animation: rx-1 2s 1.6s 2 alternate;
    }
    .grass1-2__leaf1{
      animation-timing-function: ease-in-out;
      transform-origin: right bottom;
    }
    .grass1-3__willow,
    .grass2-1__bush,
    .grass1-1__leaf1{
      animation-timing-function: ease-in-out;
      transform-origin: bottom;
    }
}

}
@keyframes rx-1 {
   0% { transform: rotate(0); }
   33% { transform: rotate(2.5deg); }
   66% { transform: rotate(-2.5deg); }
   100% { transform: rotate(0); }
}
@keyframes tx-1 {
   0% { transform: translate3d(0, 0, 0); }
   33% { transform: translate3d(5px, 0, 0); }
   66% { transform: translate3d(-5px, 0, 0); }
   100% { transform: translate3d(0, 0, 0); }
}
@keyframes loop {
   0% { fill:   #1C5F5F; }
   33% { fill: #88CBC3; }
   66% { fill: #5D8E78; }
   100% { fill: #1C5F5F; }
}
.btnBox{
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: map-get($z, 'c-h');
  position: relative;
  > a {
    margin: 0 10px;
  }
  &--info{
    position: absolute;
    bottom: 60px;
  }
   @include respond-to(sm) {
     bottom: -20px;
   }
  @include respond-to('1200') {
    position: absolute;
    bottom: 100px;
    > a {
      margin: 0 12.5px;
    }
    &--info{
    bottom: 60px;
  }
  }
   @include respond-to(xl) {
     bottom: 200px;
   }
}
.svgBox {
  &-block {
    width: 175px;
    height: 175px;
    padding: 0 15px;
    cursor: pointer;
  svg{
    transform-origin: top left;
    transform: scale(0.6);
    #item{
      transition: .4s;
    }
    &:hover{
      #item{
        transform: translate(0, 20px);
      }
    }
  }
  }
  @include respond-to(md) {
     &-block {
      height: auto;
      width: auto;
      padding: 20px 30px;
     }
    svg{
      transform: none;
    }
  }
}

.scenecontrol {
  position: relative;
  width: 100vw;
  height: 600px;
  &.step_12{
    height: 700px;
  }
  @include respond-to(sm) {
    height: 800px;
    &.step_12{
      height: 800px;
    }
  }
  @include respond-to('1200') {
    height: 100vh;
    &.step_12{
      height: 100vh;
    }
  }
  pointer-events: none;
  overflow: hidden;
}

.formBox{
  position: relative;
  max-width: 400px;
  input.type-2{
    background: $grayL;
    height: 60px;
    width: 100%;
    // max-width: 400px;
    border-radius: 5px;
    padding: 15px;
    letter-spacing: 1.3px;
    border: 1px solid transparent;
    transition: .4s;
    &._error{
      border: 1px solid $color-primaryL;
    }
  }
  &--error{
    position: absolute;
    top: 0;
    right: 10px;
    line-height: 60px;
    font-size: 14px;
    pointer-events: none;
    z-index: map-get($z, 'c-h');
  }
}

  .Fade-enter-active {
    transition: all .35s ease-in-out;
    z-index: 2;
  }

  .Fade-leave-active {
    transition: all .35s ease-in-out;
  }

  .Fade-enter {
    transform: translate3d(0, -100px, 0);
    pointer-events: none;
    opacity: 0;
  }

  .Fade-leave-to {
    transform: translate3d(0, 100px, 0);
    pointer-events: none;
    opacity: 0;
  }

  // Question transition
  .Fade-Question-enter-active {
    transition: 1.5s .5s ease-in-out;
    .l-scene{
      &--title{
        transition: .3s .5s ease-out;
      }
    }
    ul.m-answer{
      &:after,
      &:before,
      li{
        transition: .2s 1.8s ease-out;
      }
    }
    .m-question{
      &--branch{
        &:before{
          transition: .8s .2s cubic-bezier(0.68, -0.6, 0.32, 1.6);
           z-index: 2;
        }
        &:after{
          transition: .8s .5s cubic-bezier(0.68, -0.6, 0.32, 1.6);
           z-index: 0;
        }
        &__vine{
          transition: .6s 1.1s cubic-bezier(0.36, 0, 0.66, -0.56);
        }
        &__sloth{
           transition: .3s 1.7s ease-in-out;
        }
      }
      &--stone_l{
        transition: 1s .3s cubic-bezier(0.36, 0, 0.66, -0.56);
      }
      &--stone_s{
        transition: .4s 1.2s cubic-bezier(0.36, 0, 0.66, -0.56);
      }
      &--squirrel{
        transition: .5s 1.5s cubic-bezier(0.34, 1.56, 0.64, 1);
      }
      &--pine{
        transition: .4s 1.6s cubic-bezier(0.34, 1.56, 0.64, 1);
      }
      &--trunk{
        transition: .7s .8s cubic-bezier(0.68, -0.6, 0.32, 1.6);
      }
      &--slider{
        transition: .7s .6s cubic-bezier(0.36, 0, 0.66, -0.56);
      }
      &--item,
      &--owl{
        transition: .5s 1.2s ease-in-out;
      }
    }
    .btnBox{
       transition: .3s 1.8s ease-out;
    }
  }

  .Fade-Question-leave-active {
    transition: .3s ease-out;
    .l-scene{
      &--title{
        transition: .3s ease-out;
      }
    }
    ul.m-answer{
      &:after,
      &:before,
      li{
       transition: .3s ease-out;
      }
    }
    .m-question{
      &--branch{
        &:after,
        &:before{
          transition: .3s ease-out;
        }
        &__vine{
          transition: .3s ease-out;
        }
        &__sloth{
          transition: .3s ease-out;
        }
      }
      &--item,
      &--owl,
      &--slider,
      &--pine,
      &--stone_l,
      &--stone_s,
      &--squirrel,
      &--trunk{
        transition: .3s ease-out;
      }
    }
    .btnBox{
       transition: .3s ease-out;
    }
  }

  .Fade-Question-enter {
    pointer-events: none;
    .l-scene{
      &--title{
        transform: translate3d(0, 20px, 0);
        opacity: 0;
      }
    }
    ul.m-answer{
      &:after,
      &:before,
      li{
        transform: translate3d(0, 20px, 0);
        opacity: 0;
      }
    }
    .m-question{
      &--branch{
        &:after,
        &:before{
          transform: translate3d(0, 100%, 0);
        }
        &__vine{
          opacity: 0;
          transform: scale3d(0, 1, 1);
          // transform-origin: left;
        }
        &__sloth{
          opacity: 0;
          transform: translate3d(250px, 0, 0);
        }
      }
      &--stone_l{
        transform: translate3d(0, 105%, 0);
      }
      &--stone_s{
        transform: translate3d(0, 150px, 0);
      }
      &--squirrel{
        transform: translate3d(0, 150px, 0);
      }
      &--trunk{
        transform: translate3d(0, 200%, 0) rotate(25deg);
      }
      &--pine{
        opacity: 0;
        transform: translate3d(0, -75px, 0);
      }
      &--slider{
        opacity: 0;
        transform: scale3d(0, 1, 1);
        transform-origin: left;
      }
      &--item,
      &--owl{
        opacity: 0;
         transform: scale3d(0.3, 0.3, 0.3) rotate(45deg);
         transform-origin: center;
      }
    }
    .btnBox{
       transform: translate3d(0, 20px, 0);
        opacity: 0;
    }
  }

  .Fade-Question-leave-to {
    pointer-events: none;
    .l-scene{
      &--title{
        opacity: 0;
      }
    }
    ul.m-answer{
      &:after,
      &:before,
      li{
        opacity: 0;
      }
    }
    .m-question{
      &--branch{
        &:after,
        &:before{
          transform: translate3d(0, 100%, 0);
        }
        &__vine{
          opacity: 0;
        }
        &__sloth{
          opacity: 0;
        }
      }
      &--pine,
      &--trunk,
      &--squirrel,
      &--stone_s,
      &--stone_l{
        opacity: 0;
      }
      &--item,
      &--owl,
      &--slider{
        opacity: 0;
      }
    }
    .btnBox{
      opacity: 0;
    }
  }
</style>
